import {REDUCERS} from "./reducerConstants";

export function dropdownReducer(state, action) {
    switch (action.type) {
        case REDUCERS.SET_DROPDOWN_ITEMS:
            return { ...state, [action.id]: { ...state[action.id], data: action.value } };
        default:
            return state;
    }
}
